var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArrowToTop(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 14,
    viewBox: "0 0 23 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.31626 10.1242C0.535207 10.9053 0.535207 12.1716 1.31626 12.9527C2.0973 13.7337 3.36363 13.7337 4.14468 12.9527L1.31626 10.1242ZM11.4997 2.76923L12.9139 1.35501C12.1329 0.573964 10.8665 0.573964 10.0855 1.35501L11.4997 2.76923ZM18.8547 12.9527C19.6358 13.7337 20.9021 13.7337 21.6831 12.9527C22.4642 12.1716 22.4642 10.9053 21.6831 10.1242L18.8547 12.9527ZM4.14468 12.9527L12.9139 4.18344L10.0855 1.35501L1.31626 10.1242L4.14468 12.9527ZM10.0855 4.18344L18.8547 12.9527L21.6831 10.1242L12.9139 1.35501L10.0855 4.18344Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowToTop);
export default __webpack_public_path__ + "static/media/arrowToTop.9b9c9aedf900468455c133699645a225.svg";
export { ForwardRef as ReactComponent };